import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { React, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';

import PrivateAdminRoutes from './utils/PrivateAdminRoutes';
import Header from "./components/layouts/Header";
import Dashboard from './components/layouts/Dashboard';

import Login from './components/accounts/Login';
import NewClinic from './components/clinics/NewClinic';
import ClinicList from './components/clinics/ClinicList';
import ClinicDetails from './components/clinics/ClinicDetails';
import DemoRequestLlist from './components/clinics/DemoRequestList';
import { ToastContainer, toast } from 'react-toastify';

export default function App() {
	return (
		<Router>
			<AuthProvider>
				<Header applicationName="VisionThink Tech" />
				<Routes>
					<Route element={<PrivateAdminRoutes />}>
						<Route path="/" element={<Dashboard />} />
						<Route path="/clinic" element={<ClinicList />} />
						<Route path="/clinic/:clinic_id" element={<ClinicDetails />} />
						<Route path="/clinic/new" element={<NewClinic />} />
						<Route path="/demo-request" element={<DemoRequestLlist />} />
					</Route>
					<Route path="/sign-in" element={<Login />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
				<ToastContainer />
			</AuthProvider>
		</Router>
	)
}

function NotFound() {
	const navigate = useNavigate();

	useEffect(() => {
		localStorage.removeItem("AuthTokens");
		toast.error("Page not found!");
		navigate("/sign-in");
	}, [navigate]);

	return null;
}